enum EAutoScoreType {
  FRAP = 0,
  IP = 1,
}

export default EAutoScoreType;
